export default __webpack_public_path__ + "static/media/icon-health.c28cbf3c.svg";